import React from "react";
import MainLogo from "../../assets/image/logo-image.png";
import banner from "../../assets/image/jjs-banner.jpg";
const FrontPage = () => {
  return (
    <>
      <div className="text-center">
        <img
          src={banner}
          alt="Placeholder"
          className="img-fluid vh-50 w-100 top-img mb-4"
        />
      </div>
      <div className="text-center">
        <h1 className="display-1">Welcome</h1>
        <h1 className="display-4">to</h1>
        <img src={MainLogo} className="img-fluid" alt="Main Logo" />
      </div>
    </>
  );
};

export default FrontPage;
